import { render } from "./LastNMatchesStat.vue?vue&type=template&id=455d72bd&scoped=true"
import script from "./LastNMatchesStat.vue?vue&type=script&lang=js"
export * from "./LastNMatchesStat.vue?vue&type=script&lang=js"

import "./LastNMatchesStat.vue?vue&type=style&index=0&id=455d72bd&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455d72bd"]])

export default __exports__